import styled, { css } from "styled-components";
import { lighten, readableColor } from 'polished';
import { Alert, Box, Button, Col, Row } from "@intech/web-ui";
import { device } from "../../device";

export const GrayBox = styled(Box)`
  color: #7c7e80;
`;

export const Title = styled.h4`
  font-size: 20px;
`;

export const GreenSpan = styled.span`
  color: ${props => lighten(0.05, props.theme.colors.green)};
`;

export const SmallButton = styled(Button)`
  width: inherit;
`;

export const SmallAlert = styled(Alert)`
  align-self: baseline;
  width: inherit;
`;

export const Label = styled.div`
  text-align: right;
  padding: calc(0.375rem + 1px) 15px;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 1.5;
  position: relative;
  width: 100%;
  @media ${device.tablet} {
    flex: 0 0 15%;
    max-width: 15%;
  }
  @media not ${device.tablet} {
    text-align: left;
  }
`;

export const FlexedColumn = styled(Col)`
  @media not ${device.tablet} {
    flex-direction: column;
  }
`;

export const Select = styled.select`
  background-image: none;
  display: block;
  width: inherit;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  word-wrap: normal;
  text-transform: none;
  margin: 0;
  font-family: inherit;
`;

export const WrapRow = styled(Row)`
  flex-wrap: wrap;
`;
